module.exports = __webpack_public_path__ + "img/our.b9dda1bb.png";